
export const GIBIER_TYPES = [
  {id: "Aucun", description: "Aucun"},
  {id: "Petit", description: "Petit"}, 
  {id: "Gros", description: "Gros"}, 
]
export const GIBIER = [
  {id: "0A", description: "Autre"}, 
  {id: "0B", description: "Bécasse"}, 
  {id: "0C", description: "Canard"}, 
  {id: "0D", description: "Caribou"}, 
  {id: "0E", description: "Bernache du Canada"}, 
  {id: "0G", description: "Gélinotte huppée"}, 
  {id: "0L", description: "Lièvre d'Amérique"}, 
  {id: "0N", description: "Ours noir"}, 
  {id: "0O", description: "Orignal"}, 
  {id: "0S", description: "Sauvagine"}, 
  {id: "0T", description: "Tétras du Canada"}, 
  {id: "0V", description: "Cerf de virginie"}, 
]
export const ESPECES = [
  { id:"A", description:"Autre"}, 
  { id:"D", description:"Doré jaune"},
  { id:"B", description:"Brochet"},
  { id:"S", description:"Saumon"}, 
  { id:"F", description:"Omble de Fontaine"},
  { id:"O", description:"Ouananiche"}, 
  { id:"T", description:"Touladi"},
  { id:"C", description:"Truite-arc-en-ciel"}, 
  { id:"COR", description:"Corégone"}, 
  { id:"OCA", description:"Omble chevalier (Anadrome)"}, 
  { id:"OCD", description:"Omble chevalier (Eau douce)"}, 
  { id:"TB", description:"Truite brune"}, 
  { id:"TM", description:"Truite de mer"},  
]
export const GROS_GIBIER = [
  {id: "1A", description: "Autre"}, 
  {id: "1C", description: "Caribou"}, 
  {id: "1D", description: "Cerf de Virginie"}, 
  {id: "1O", description: "Orignal"}, 
  {id: "1S", description: "Ours noir"}, 
]